
import wxjssdk from '@/libs/wxjssdk.mixin'
import XButton from 'vux/src/components/x-button/index.vue'

export default{
mixins: [ wxjssdk ],
components: {
XButton
},
data () {
return {
show: false,
}
},
methods: {
showSuccess () {
this.show = true
},
close () {
this.$wechat.closeWindow()
}
}
}



// WEBPACK FOOTER //
// ./src/views/public/signup-success.vue